import { render, staticRenderFns } from "./DwDetail.vue?vue&type=template&id=5d669904&scoped=true"
import script from "./DwDetail.vue?vue&type=script&lang=js"
export * from "./DwDetail.vue?vue&type=script&lang=js"
import style0 from "./DwDetail.vue?vue&type=style&index=0&id=5d669904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d669904",
  null
  
)

export default component.exports